
import store from '@/store';
import router from '@/router';
import CustomButton from '@/components/vuetifyComponents/CustomButton.vue';
import {
    SettlementType,
    FeePayerType,
    GatewaySettlementSettings
} from '@/interfaces/panel/gateway-settlement-settings';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "GateWaySettingPage",

    components: {
        CustomButton
    },

    data() {
        return {
            formValid: false,
            isSaving: false,
            rules: {
                min0: (value: number | null) => value === null || value >= 0 || 'مقدار نمی‌تواند منفی باشد',
                max100: (value: number | null) => value === null || value <= 100 || 'درصد نمی‌تواند بیشتر از 100 باشد',
                timeFormat: (value: string | null) => {
                    if (!value) return true;
                    const timeRegex = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
                    return timeRegex.test(value) || 'فرمت زمان نامعتبر است (HH:MM)';
                }
            },

            // Select Items
            settlementTypeItems: [
                { title: 'تسویه فوری', value: SettlementType.Instant },
                { title: 'تسویه دوره‌ای', value: SettlementType.Cycle },
                { title: 'دستی', value: SettlementType.OnDemand }
            ],

            feePayerTypeItems: [
                { title: 'مشتری', value: FeePayerType.CUSTOMER },
                { title: 'تجاری', value: FeePayerType.BUSINESS }
            ]
        };
    },

    computed: {
        getLoadingPanel(): boolean {
            return store.getters["panel/getLoadingPanel"];
        },

        getGatewaySettlementSettings(): GatewaySettlementSettings | null {
            return store.getters["panel/getGatewaySettlementSettings"];
        }
    },

    methods: {
        async loadSettings(): Promise<void> {

            const id = this.$route.query.gateway as string;
            if (!id) {
                throw new Error('شناسه درگاه یافت نشد');
            }

            await store.dispatch('panel/getGatewaySettlementSettingsRequest', id);
        },

        async updateSettings(): Promise<void> {
            if (!this.formValid || this.isSaving) {
                return;
            }

            const id = this.$route.query.gateway as string;
            const settings = this.getGatewaySettlementSettings;
            if (!id || !settings) {
                store.dispatch('app/updateToastModal', {
                    status: true,
                    type: 'danger',
                    message: 'اطلاعات درگاه برای ذخیره تنظیمات کامل نیست',
                }, { root: true });
                return;
            }
            const data = {
                rialiSettlementType: settings.rialiSettlementType,
                rialiCycleFixedFee: settings.rialiCycleFixedFee,
                rialiCyclePercentageFee: settings.rialiCyclePercentageFee,
                rialiCycleFeeCap: settings.rialiCycleFeeCap,
                rialiInstantFixedFee: settings.rialiInstantFixedFee,
                rialiInstantPercentageFee: settings.rialiInstantPercentageFee,
                rialiInstantFeeCap: settings.rialiInstantFeeCap,
                rialiTransactionFeeCap: settings.rialiTransactionFeeCap,
                rialiCycleSettlementTime: settings.rialiCycleSettlementTime,
                rialiFeePayerType: settings.rialiFeePayerType,
                isRialiSettlementEnabled: settings.isRialiSettlementEnabled,
                usdtSettlementType: settings.usdtSettlementType,
                usdtCycleFixedFee: settings.usdtCycleFixedFee,
                usdtCyclePercentageFee: settings.usdtCyclePercentageFee,
                usdtInstantFixedFee: settings.usdtInstantFixedFee,
                usdtInstantPercentageFee: settings.usdtInstantPercentageFee,
                usdtMinimumSettlement: settings.usdtMinimumSettlement,
                usdtFeePayerType: settings.usdtFeePayerType,
                isUsdtSettlementEnabled: settings.isUsdtSettlementEnabled,
            };

            this.isSaving = true;
            try {
                await store.dispatch('panel/updateGatewaySettlementSettings', {
                    gatewayId: id,
                    data,
                });
            } catch (error) {
                console.error("Error updating gateway settlement settings:", error);
            } finally {
                this.isSaving = false;
            }
        },

        back() {
            router.back();
        }
    },

    mounted() {
        this.loadSettings();
    },
});
